import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { TerminationReportComponent } from './reports/terminationreport/terminationreport.component';
import { InternalErrorComponent } from './shared/error/internalerror/internalerror.component';
import { LogoutComponent } from './logout/logout.component';
import { CallbackComponent } from './auth/callback/callback.component';

import { CustomOktaAuthGuard } from './auth/oktaauth.guard';
import { NotfoundComponent } from './shared/error/notfound/notfound.component';
import { UnauthorizedComponent } from './shared/error/unauthorized/unauthorized.component';
import { CompareGroupsComponent } from './comparegroup/comparegroups/comparegroups.component';
import { IAMRoleGuard } from './auth/roleguard.guard';
import { CompareGroupDetailComponent } from './comparegroup/comparegroupdetail/comparegroupdetail.component';
import { LoadReportComponent } from './shared/loadreport/loadreport.component';
import { LoadReportWithFiltersComponent } from './shared/loadreportwithfilters/loadreportwithfilters.component';
import { LandingpageComponent } from './landingpage/landingpage.component';
import { SelfcomparegroupsComponent } from './comparegroup/selfcomparegroups/selfcomparegroups.component';
import { SelfCompareGroupDetailComponent } from './comparegroup/selfcomparegroupdetail/selfcomparegroupdetail.component';
import { LoadreportV2Component } from './shared/loadreport-v2/loadreport-v2.component';

const routes: Routes = [
  { path: '', component: LandingpageComponent, pathMatch: 'full', canActivate: [CustomOktaAuthGuard, IAMRoleGuard] },
  { path: 'implicit/callback', component: CallbackComponent },
  { path: 'home', component: HomeComponent, canActivate: [CustomOktaAuthGuard] },
  { path: 'loadreportv1/:reportId', component: LoadReportComponent, canActivate: [CustomOktaAuthGuard] },
  { path: 'loadreport/:reportId', component: LoadReportWithFiltersComponent, canActivate: [CustomOktaAuthGuard] },
  { path: 'loadreportv2/:reportId', component: LoadreportV2Component, canActivate: [CustomOktaAuthGuard] },
  { path: 'selfcomparegroups', component: SelfcomparegroupsComponent, canActivate: [CustomOktaAuthGuard] },
  { path: 'selfcomparegroups/:orgId', component: SelfcomparegroupsComponent, canActivate: [CustomOktaAuthGuard] },
  { path: 'comparegroups', component: CompareGroupsComponent, canActivate: [CustomOktaAuthGuard] },
  { path: 'comparegroups/:orgId', component: CompareGroupsComponent, canActivate: [CustomOktaAuthGuard] },
  { path: 'comparegroupdetail/:orgId/:groupId', component: CompareGroupDetailComponent, canActivate: [CustomOktaAuthGuard]},
  { path: 'selfcomparegroupdetail/:orgId/:groupId', component: SelfCompareGroupDetailComponent, canActivate: [CustomOktaAuthGuard]},
  { path: 'comparegroupdetail/:orgId', component: CompareGroupDetailComponent, canActivate: [CustomOktaAuthGuard]},
  { path: 'selfcomparegroupdetail/:orgId', component: SelfCompareGroupDetailComponent, canActivate: [CustomOktaAuthGuard]},
  { path: 'logout', component: LogoutComponent, canActivate: [CustomOktaAuthGuard] },
  { path: 'error', component: InternalErrorComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: 'notfound', component: NotfoundComponent },
  { path: '**', redirectTo: '/notfound' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
